import { UserInformation } from '@model';
import { Action } from '@ngrx/store';
import { UserInformationEffects } from '../effects/user-information.effects';

export enum UserInformationActionTypes {
  LoadUserInformation = '[UserInformation] Load',
  LoadUserInformationSuccess = '[UserInformation] Load success',
  LoadUserInformationFail = '[UserInformation] Load fail',
  InformationSetAsRead = '[UserInformation] Set information as read',
  InformationSetAsReadSuccess = '[UserInformation] Set information as read success',
  InformationSetAsReadFail = '[UserInformation] Set information as read fail'
}

export class LoadUserInformation implements Action {
  readonly type = UserInformationActionTypes.LoadUserInformation;
  constructor() {}
}

export class LoadUserInformationSuccess implements Action {
  readonly type = UserInformationActionTypes.LoadUserInformationSuccess;
  constructor(public payload: UserInformation[]) {}
}

export class LoadUserInformationFail implements Action {
  readonly type = UserInformationActionTypes.LoadUserInformationFail;
  constructor(public payload: any) {}
}

export class InformationSetAsRead implements Action {
  readonly type = UserInformationActionTypes.InformationSetAsRead;
  constructor(public payload: number) {}
}

export class InformationSetAsReadSuccess implements Action {
  readonly type = UserInformationActionTypes.InformationSetAsReadSuccess;
  constructor(public payload: UserInformation) {}
}

export class InformationSetAsReadFail implements Action {
  readonly type = UserInformationActionTypes.InformationSetAsReadFail;
  constructor(public payload: any) {}
}

export type UserInformationActions =
  | LoadUserInformation
  | LoadUserInformationSuccess
  | LoadUserInformationFail
  | InformationSetAsRead
  | InformationSetAsReadSuccess
  | InformationSetAsReadFail;
